export enum DateFormat {
    MMDDYYYY = 'MM/dd/yyyy',
    YYYYMMDD = 'yyyy-MM-dd',
    MDYhma = 'MM/dd/yyyy hh:mm a',
    hma = 'hh:mm a',
    hmaz = 'hh:mm a z',
    YMDhmsz = 'yyyy-MM-dd HH:mm:ss zzz',
}
